import CustomChip from '@app/components/atoms/CustomChip/CustomChip'
import MenuItem from '@app/components/MenuItem'
import ModalUpdateStatus from '@app/components/ModalUpdateStatus'
import OptionMenu from '@app/components/OptionMenu'
import { VOUCHER_STATUS } from '@app/constant/VoucherConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import { formatNumber, formatPrice, toDateTime, toRemainingTime } from '@app/libs/format'
import { Inertia } from '@inertiajs/inertia'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import Chip from '@mui/material/Chip'
import { green, red } from '@mui/material/colors'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const VoucherRequestedInformation = ({ vouchersRequested }) => {
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const [modalName, setModalName] = useState('')

  const [openModalConfirm, setOpenModalConfirm] = useState(false)

  const handleCloseModal = () => setOpenModalConfirm(false)

  const handleVoucher = (status) => {
    handleClose()
    setModalName(status)
    setOpenModalConfirm(true)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={11}>
        <Typography variant="h4">{vouchersRequested.name}</Typography>
      </Grid>

      <Grid item justifyContent="flex-end" xs={1}>
        {vouchersRequested.status === VOUCHER_STATUS.REQUESTED && (
          <OptionMenu anchorEl={anchorEl} handleClick={handleClick} handleClose={handleClose} open={null !== anchorEl}>
            <MenuItem
              icon={CheckIcon}
              iconColor={green[600]}
              name={t('BUTTON.APPROVE')}
              onClick={() => handleVoucher(VOUCHER_STATUS.APPROVE)}
            />
            <MenuItem
              icon={CloseIcon}
              iconColor={red[600]}
              name={t('BUTTON.REJECT')}
              onClick={() => handleVoucher(VOUCHER_STATUS.REJECTED)}
            />
          </OptionMenu>
        )}
      </Grid>
      {[VOUCHER_STATUS.APPROVE, VOUCHER_STATUS.REJECTED].includes(modalName) && (
        <ModalUpdateStatus
          content={
            VOUCHER_STATUS.APPROVE === modalName
              ? t('MODAL.VOUCHER_APPROVE_CONTENT')
              : t('MODAL.VOUCHER_REJECT_CONTENT')
          }
          handleCloseModal={handleCloseModal}
          handleSubmit={() => {
            Inertia.get(
              route('admin.vouchers.requested.status.change', {
                vouchersRequested: vouchersRequested.id,
                status: VOUCHER_STATUS.APPROVE === modalName ? VOUCHER_STATUS.ACTIVE : VOUCHER_STATUS.REJECTED,
              })
            )
          }}
          openModalConfirm={openModalConfirm}
          title={VOUCHER_STATUS.APPROVE === modalName ? t('MODAL.VOUCHER_APPROVE') : t('MODAL.VOUCHER_REJECT')}
        />
      )}
      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.MERCHANT_NAME')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        <Typography variant="body1">{vouchersRequested.merchant.name}</Typography>
      </Grid>

      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.TYPE_VOUCHER')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        <CustomChip color={vouchersRequested.type} label={t(`VOUCHER.${vouchersRequested.type.toUpperCase()}`)} />
      </Grid>

      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.PRICE')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        <Typography variant="body1">{formatPrice(vouchersRequested.price)}</Typography>
      </Grid>

      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.QUANTITY')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        <Typography variant="body1">{formatNumber(vouchersRequested.quantity)}</Typography>
      </Grid>

      {VOUCHER_TYPE.PREMIUM === vouchersRequested.type && (
        <>
          <Grid item xs={3}>
            <Typography color="textSecondary" variant="body1">
              {t('VOUCHER.MIN')}
            </Typography>
          </Grid>

          <Grid item xs={9}>
            {vouchersRequested.limit_min ? (
              <Typography variant="body1">{vouchersRequested.limit_min}</Typography>
            ) : (
              <Typography variant="body1">{t('DATA.NO_DATA')}</Typography>
            )}
          </Grid>

          <Grid item xs={3}>
            <Typography color="textSecondary" variant="body1">
              {t('VOUCHER.MAX')}
            </Typography>
          </Grid>

          <Grid item xs={9}>
            {vouchersRequested.limit_max ? (
              <Typography variant="body1">{vouchersRequested.limit_max}</Typography>
            ) : (
              <Typography variant="body1">{t('DATA.NO_DATA')}</Typography>
            )}
          </Grid>
        </>
      )}

      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.CATEGORIES')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        {vouchersRequested.categories.map((item) => (
          <Chip key={item.id} label={item.name} sx={{ margin: '2px' }} />
        ))}
      </Grid>

      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.EXPIRED_DATE')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        <Typography variant="body1">{toDateTime(vouchersRequested.expired_date)}</Typography>
      </Grid>

      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.REMAIN_TIME')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        {vouchersRequested.expired_date ? (
          toRemainingTime(new Date(), vouchersRequested.expired_date)
        ) : (
          <Typography variant="body1">{t('DATA.NO_DATA')}</Typography>
        )}
      </Grid>

      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.STATUS')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        <CustomChip color={vouchersRequested.status} label={t(`VOUCHER.${vouchersRequested.status.toUpperCase()}`)} />
      </Grid>

      <Grid item xs={3}>
        <Typography color="textSecondary" variant="body1">
          {t('VOUCHER.HASHTAGS')}
        </Typography>
      </Grid>

      <Grid item xs={9}>
        {vouchersRequested.tags.length ? (
          vouchersRequested.tags.map((item) => <Chip key={item.id} label={item.name} style={{ margin: '2px' }} />)
        ) : (
          <Typography variant="body1">{t('DATA.NO_DATA')}</Typography>
        )}
      </Grid>
    </Grid>
  )
}

export default VoucherRequestedInformation
